import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ClipboardCheck, Receipt } from "lucide-react";
import { api } from "@/lib/api";
import { fmtEUR, fmtDate } from "@/constants/labels";

const LABEL = { brouillon: "brouillon", envoyee: "envoyée", acceptee: "acceptée", refusee: "refusée", facturee_partielle: "facturée partiellement", soldee: "soldée" };

/** Vue synthétique mission → commande → facture(s) + bouton d'entrée dans la chaîne. */
export const MissionChaine = ({ mission, role }) => {
  const [cmd, setCmd] = useState(undefined);
  useEffect(() => {
    api.get(`/commandes?mission_id=${mission.id}`).then((r) => setCmd((r.data || []).find((c) => c.statut !== "refusee") || null)).catch(() => setCmd(null));
  }, [mission.id]);
  if (cmd === undefined) return null;
  const canCreate = role === "entreprise" && ["acceptee", "en_cours", "terminee"].includes(mission.statut);
  if (!cmd) {
    return canCreate ? (
      <Link to={`/app/commandes?mission=${mission.id}&new=1`} className="btn-outline text-xs inline-flex items-center gap-1" data-testid={`mission-commande-create-${mission.id}`}>
        <ClipboardCheck size={12} /> Créer une commande de travaux
      </Link>
    ) : null;
  }
  return (
    <div className="text-xs text-[#1F2933] bg-[#F5F3EE] border border-[#E4E7EB] rounded-[4px] px-2.5 py-2 space-y-0.5" data-testid={`mission-chaine-${mission.id}`}>
      <div>
        <Link to={`/app/commandes?mission=${mission.id}`} className="font-semibold underline text-[#1B3A5C]" data-testid={`mission-commande-view-${mission.id}`}>Commande {cmd.numero || "(brouillon)"}</Link>
        {" "}{LABEL[cmd.statut] || cmd.statut}{cmd.accepted_at ? ` le ${fmtDate(cmd.accepted_at)}` : ""} — <b>{fmtEUR(cmd.montant_ht)}</b> HT
      </div>
      {["acceptee", "facturee_partielle", "soldee"].includes(cmd.statut) && (
        <div>Facturé : <b>{fmtEUR(cmd.montant_facture_ht)}</b> — Reste à facturer : <b data-testid={`mission-reste-${mission.id}`}>{fmtEUR(cmd.reste_a_facturer_ht)}</b>
          {cmd.factures?.filter((f) => f.statut === "emise").map((f) => (
            <Link key={f.id} to={`/app/factures?facture=${f.id}`} className="ml-2 underline text-[#1B3A5C] inline-flex items-center gap-0.5"><Receipt size={10} /> {f.numero}</Link>
          ))}
          {cmd.brouillon_id && <span className="ml-2 text-[#7C3E00]">+ 1 brouillon en cours</span>}
        </div>
      )}
    </div>
  );
};
